const SIZE = Object.freeze({
	TWO: 2,
	FOUR: 4,
})

const GRID_SIZE = Object.freeze({
	[SIZE.TWO]: 6,
	[SIZE.FOUR]: 3,
	DEFAULT: 3,
})

export default GRID_SIZE
